import OpenAIModels from '../lib/models/OpenAIModels';

export default {
  selectedGptModelValue: (state) => state.gptModel,
  selectedGptModelName: (state) => OpenAIModels.getModelNameByValue(state.gptModel),  
};
